import { render, staticRenderFns } from "./UsuarioPWA.vue?vue&type=template&id=5ef46f02&"
import script from "./UsuarioPWA.vue?vue&type=script&lang=js&"
export * from "./UsuarioPWA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports